import script from "./NavbarSection.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarSection.vue?vue&type=script&setup=true&lang=js"

import "./NavbarSection.vue?vue&type=style&index=0&id=28a2cdb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a2cdb2"]])

export default __exports__